import { ColorManagement, LinearSRGBColorSpace, OrthographicCamera, PerspectiveCamera, Scene, WebGLRenderer } from 'three';

// Wyłącz Color Management aby zachować renderowanie kolorów jak w starszych wersjach Three.js
ColorManagement.enabled = false;
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';

export default class RenderingContext<Camera extends OrthographicCamera | PerspectiveCamera> {
  public scene: Scene;
  public renderer: WebGLRenderer;
  public camera: Camera;
  public cameraControls: OrbitControls;

  constructor(scene: Scene, renderer: WebGLRenderer, camera: Camera) {
    this.scene = scene;
    this.renderer = renderer;
    this.camera = camera;
  }

  public static get(containerElement: HTMLElement) {
    const width = containerElement.clientWidth;
    const height = containerElement.clientHeight;

    const camera = new PerspectiveCamera(0.1, width / height, 1000, 35000000);
    const scene = new Scene();
    const renderer = new WebGLRenderer({
      antialias: true,
      alpha: true,
      preserveDrawingBuffer: true,
    });

    renderer.setClearColor(0xffffff);
    renderer.outputColorSpace = LinearSRGBColorSpace;
    renderer.setSize(width, height, false);
    containerElement.appendChild(renderer.domElement);
    return new RenderingContext(scene, renderer, camera);
  }
}
